export default __webpack_public_path__ + "static/media/s9.7e11567b.jpg";